/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Permissions_Action_PlaceholderInputs */

const en_admin_permissions_action_placeholder = /** @type {(inputs: Admin_Permissions_Action_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. create`)
};

/**
* | output |
* | --- |
* | "e.g. create" |
*
* @param {Admin_Permissions_Action_PlaceholderInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_permissions_action_placeholder = /** @type {((inputs?: Admin_Permissions_Action_PlaceholderInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Permissions_Action_PlaceholderInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_permissions_action_placeholder(inputs)
});
export { admin_permissions_action_placeholder as "admin.permissions.action_placeholder" }